import { Container } from '../ui/Container'
import { CTA } from '../ui/CTA'
import { Eyebrow } from '../ui/Eyebrow'
import { Reveal } from '../ui/Reveal'

export function ProductsFeature() {
  return (
    <section className="border-b border-ink/10 bg-night py-24 text-snow md:py-32">
      <Container>
        <Reveal>
          <Eyebrow>Products</Eyebrow>
          <h2 className="mt-6 max-w-2xl font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-5xl">
            We don&apos;t only build for others. We build products of our own.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-snow/70">
            Some problems appear again and again. When we identify an opportunity to solve one at
            scale, we turn the solution into a product.
          </p>
        </Reveal>

        <Reveal delay={150}>
          <div className="mt-16 rounded-3xl border border-snow/10 bg-snow/[0.03] p-8 md:p-12">
            <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
              <div>
                <span className="font-display text-3xl font-semibold tracking-tight text-signal">
                  Jokor
                </span>
                <p className="mt-4 max-w-md text-base leading-relaxed text-snow/80">
                  A digital commerce platform for businesses. Jokor helps businesses establish their
                  digital presence, showcase what they offer, connect with customers, and manage
                  everyday commerce.
                </p>
              </div>
              <div className="flex flex-wrap gap-4">
                <CTA to="/products#jokor" variant="secondaryOnDark" className="w-fit">
                  Explore Jokor
                </CTA>
                <CTA href="https://jokor.online" variant="ghostOnDark" className="w-fit">
                  Visit jokor.online
                </CTA>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-6 rounded-3xl border border-snow/10 bg-snow/[0.03] p-8 md:p-12">
            <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
              <div>
                <span className="font-display text-3xl font-semibold tracking-tight text-signal">
                  CarNerx
                </span>
                <p className="mt-4 max-w-md text-base leading-relaxed text-snow/80">
                  A car marketplace platform. CarNerx connects car buyers and sellers in one place.
                </p>
              </div>
              <div className="flex flex-wrap gap-4">
                <CTA to="/products#carnerx" variant="secondaryOnDark" className="w-fit">
                  Explore CarNerx
                </CTA>
                <CTA href="https://carnerx.co" variant="ghostOnDark" className="w-fit">
                  Visit carnerx.co
                </CTA>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={250}>
          <div className="mt-10 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
            <p className="text-sm text-snow/60">More products are being built.</p>
            <CTA to="/products" variant="ghostOnDark">
              Explore products
            </CTA>
          </div>
        </Reveal>
      </Container>
    </section>
  )
}
